import { Reveal, Overline } from "./Reveal";
import { REASONS } from "../../data/site";

const CRAFT_IMG = "https://images.unsplash.com/photo-1631396326838-de37e5f8bcbc";

export const WhyChooseUs = () => {
    return (
        <section
            id="kelebihan"
            data-testid="why-choose-us"
            className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36"
        >
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
                <div>
                    <Reveal>
                        <Overline>Kenapa Pilih Kami</Overline>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink max-w-2xl leading-[1.02]">
                            Dibina dengan teliti, disayangi si comel.
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.16}>
                    <p className="max-w-sm text-ink-soft leading-relaxed">
                        Empat sebab utama mengapa ribuan pemilik kucice mempercayai
                        astana buatan tangan kami.
                    </p>
                </Reveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
                {REASONS.map((r, i) => (
                    <Reveal key={r.no} delay={i * 0.08} className={r.span}>
                        <div className="group h-full border border-border bg-surface p-8 md:p-10 hover:bg-surface-2 transition-colors duration-500">
                            <div className="flex items-center justify-between">
                                <span className="font-mono text-xs tracking-[0.2em] text-accent">
                                    {r.no}
                                </span>
                                <span className="h-px w-12 bg-border group-hover:w-20 group-hover:bg-accent transition-all duration-500" />
                            </div>
                            <h3 className="mt-8 font-display text-2xl md:text-3xl text-ink tracking-tight">
                                {r.title}
                            </h3>
                            <p className="mt-4 text-ink-soft leading-relaxed">{r.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1}>
                <div className="mt-8 relative overflow-hidden border border-border aspect-[16/7]">
                    <img
                        src={CRAFT_IMG}
                        alt="Kraftangan tempatan"
                        className="h-full w-full object-cover hover:scale-105 transition-transform duration-[900ms]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-bg/70 to-transparent" />
                    <div className="absolute left-8 bottom-8 md:left-12 md:bottom-12">
                        <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-accent">
                            Buatan Tangan
                        </span>
                        <p className="mt-3 font-display text-2xl md:text-4xl text-ink max-w-md leading-tight">
                            Setiap sambungan diukur, setiap kemasan dihalusi.
                        </p>
                    </div>
                </div>
            </Reveal>
        </section>
    );
};
